import CaretBottomIcon from 'assets/icons/landing/caret-bottom'
import PhoneIcon from 'assets/icons/landing/phone'
import WhatsappIcon from 'assets/icons/landing/wa'
import PrimaryButton from 'components/UI/Landing/button-primary'
import Typography from 'components/UI/Typography'
import { Cycle, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-scroll'
import tw from 'twin.macro'
import { useLockedBody } from 'usehooks-ts'

const links = [
  {
    title: 'mobile-menu.main-section',
    name: 'main-section'
  },
  {
    title: 'mobile-menu.calc-section',
    name: 'calculator-section'
  },
  {
    title: 'mobile-menu.terms-section',
    name: 'terms-section'
  },
  {
    title: 'mobile-menu.steps-section',
    name: 'steps-section'
  },
  {
    title: 'mobile-menu.pros-section',
    name: 'pros-section'
  },
  {
    title: 'mobile-menu.faq-section',
    name: 'faq-section'
  }
]

const MobileMenu = ({ isOpen, onToggle }: { isOpen: boolean; onToggle: Cycle }) => {
  const { t } = useTranslation('landing')

  useLockedBody(isOpen)

  if (!isOpen) return null

  return (
    <motion.div
      css={[
        isOpen &&
          tw`absolute top-[67px] bottom-0 left-0 w-full h-screen bg-[var(--bg-landing-main)] pt-10 overflow-hidden z-30`
      ]}
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
    >
      <div tw='flex flex-col gap-10 px-4'>
        {links.map((el, key) => {
          return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
              activeClass='active'
              to={el.name}
              spy
              smooth
              duration={500}
              offset={-60}
              tw='flex items-center justify-between cursor-pointer'
              key={key}
              onClick={() => {
                onToggle()
              }}
            >
              <Typography twStyle={tw`font-bold text-[20px] leading-[140%]`}>{t(el.title)}</Typography>
              <div tw='-rotate-90'>
                <CaretBottomIcon />
              </div>
            </Link>
          )
        })}
        <PrimaryButton
          type='button'
          tw='w-full sm:w-auto lg:block'
          onClick={() => {
            window.scrollTo({
              behavior: 'smooth',
              top: 950
            })
            onToggle()
          }}
        >
          {t('mobile-menu.btn-text')}
        </PrimaryButton>
        <div tw='flex flex-col self-center gap-[24px]'>
          <a
            href='https://api.whatsapp.com/send?phone=77761595595'
            tw='flex items-center gap-2 justify-center'
            target='_blank'
            rel='noreferrer'
          >
            <span tw='p-1 bg-[var(--bg-header-icon)] h-8 w-8 rounded-full flex items-center justify-center'>
              <WhatsappIcon />
            </span>
            +7 776 159 5595
          </a>
          <a href='tel:595' tw='flex items-center gap-2 justify-center' rel='noreferrer'>
            <span tw='p-1 bg-[var(--bg-header-icon)] rounded-full h-8 w-8 flex items-center justify-center'>
              <PhoneIcon />
            </span>
            595
          </a>
        </div>
        <div
          tw='rounded-full opacity-[0.2] absolute w-[659px] h-[659px] top-[500px] left-[-350px]'
          style={{
            background: 'linear-gradient(313.18deg, #52D878 32.58%, #46C8E0 93.46%)',
            filter: 'blur(115.5px)'
          }}
        ></div>
      </div>
    </motion.div>
  )
}

export default MobileMenu
